import { Outlet, useLocation } from 'react-router-dom';
import { WregShell } from '@/components/webreg/WregShell';
import { WregDevPanel } from '@/components/webreg/WregDevPanel';
import { WregFlowProvider, useWregFlowActions } from '@/components/webreg/WregFlowProvider';
import { useWregNav } from '@/components/webreg/useWregNav';
import { useWregDev } from '@/components/webreg/dev/WregDevContext';
import { WREG_SCENARIO_CODE, WREG_SCENARIO_END } from '@/components/webreg/wregScenarios';

const WregShellHost = () => {
  const location = useLocation();
  const { step, canBack, back } = useWregNav();
  const { helpOpen, setHelpOpen } = useWregFlowActions();

  return (
    <WregShell
      step={step}
      canBack={canBack}
      onBack={back}
      helpOpen={helpOpen}
      onHelpOpenChange={setHelpOpen}
    >
      <Outlet key={location.pathname} />
    </WregShell>
  );
};

const WregDevPanelHost = () => {
  const dev = useWregDev();
  const { startOver, jumpToEnd } = useWregFlowActions();

  if (!dev.enabled) return null;

  return (
    <WregDevPanel
      scenario={dev.scenario}
      onScenario={(id) => {
        dev.setScenario(id);
        dev.setMockCode(WREG_SCENARIO_CODE[id]);
        startOver();
      }}
      code={dev.mockCode}
      onCode={(code) => {
        dev.setMockCode(code);
        startOver();
      }}
      live={dev.live}
      onLive={dev.setLive}
      disclosure={dev.disclosure}
      onDisclosure={dev.setDisclosure}
      onEnd={(id) => {
        dev.setScenario(id);
        dev.setMockCode(WREG_SCENARIO_CODE[id]);
        const target = WREG_SCENARIO_END[id];
        if (target) jumpToEnd(target);
      }}
    />
  );
};

const WregLayout = () => (
  <WregFlowProvider>
    <WregShellHost />
    <WregDevPanelHost />
  </WregFlowProvider>
);

export { WregLayout };
